import * as Ajax from "../../pwa/ajax";
import * as BucketTools from "../common/bucket";
import * as Utilities from "../common/utilities";
import {sugerenciasPie, sugerenciasPerso, newsletter} from "../../../Settings/global/nota.json";
import * as Cookie from '../common/cookie';

const urlRankingMultiplesCategoriaUrl = window.config.Statics.ApiContenidoUrlRaiz + window.config.Statics.ApiRankingMultiplesCategoriaUrl;
const urlApiCategorias = window.config.Statics.ApiContenidoUrlRoot + "categoriastags?categoriasId=";
const urlApiLogin = window.config.Statics.APILoginUrl;
const bucket = window.config.Statics.BucketUrl;
const urlApiNewsletter = urlApiLogin + window.config.Statics.ApiNewsletterSugerenciaUrl;
const urlApiSuscribirse =  urlApiLogin + window.config.Statics.ApiUrlSuscribirse;
const urlBucket = window.config.Statics.BucketUrl;

/////////////////////////////////////TE PUEDE INTERESAR - NOTA///////////////////////////////////////////////////////////////////
export const sugerencias = () => {
    let notas = JSON.parse(localStorage.getItem("obtenerSugerencias"));
    if (notas != null && notas.length > 0) { 
        
        notas = notas.filter(item => item.datos != null && item.datos.imagen !== null && item.datos.imagen !== undefined);
        
        //Purgar nota actual de listado de sugerencias.
        notas = purgarNotaDeSugerencias(notas);

        let notasBloque1 = notas.slice(0, 7);
        let notasBloque2 = notas.slice(7, 15);
        let notasBloque3 = notas.slice(15, 20);
        let contador = 0;
        let toi = 801;
        let html = `<aside class="puede-interesar" id="bloque-3" data-is-block="true" data-block-name="n_sugerencias" data-diagramacion-id="0">
                    <div class="fila-1 floatFix" id="sugeridasBloque3F1">
                    <h4>Te puede interesar</h4>
                    <div class="columna-doble">${getArticleSugerido(notas[0], 514,137,toi)}</div>`;
    
        let article = "";
        notasBloque1.shift();
        for (var nota of notasBloque1) {
            toi++;
            article += getArticleSugerido(nota, 216,137,toi);
            contador++;
            
            if (contador % 2 === 0) {
                html += `<div class="columna">${article}</div>`;
                article = "";
            }
        }
        html += "</div>";
       
        if(notasBloque2.length === 8)
        {
            html += `<div class="fila-2 floatFix" id="sugeridasBloque3F2">`;
            article = "";
            contador = 0;
            for (var nota of notasBloque2) {
                toi++;
                article += getArticleSugerido(nota, 216,137,toi);
                contador++;
                if (contador % 2 === 0) {
                    html += `<div class="columna">${article}</div>`;
                    article = "";
                }
                if (contador === 5) {
                    toi++;
                    article = getArticleSugerido(nota, 514,137,toi);
                    html += `<div class="columna-doble">${article}</div>`;
                    article = "";
                    contador++;
                }
            }
            html += `</div>`;
        }
        
        if(notasBloque3.length === 5)
        {
            html += `<div class="fila-3 floatFix" id="sugeridasBloque3F3">`;
            for (var nota of notasBloque3) {
                toi++;
                html += getArticleSugerido(nota, 216,137,toi);
            }
            html += `</div></aside>`;
        }        
        document.querySelector('div[data-module="nota-sugeridas"]').innerHTML = html; 
    }
}

const purgarNotaDeSugerencias = (notas) => {
    const notaId = document.querySelector("div[data-notaId]").getAttribute("data-notaId");

    notas.forEach((laNota, index) => {
        if (laNota.contenido_id === parseInt(notaId))
            notas.splice(index, 1);
    });
    return notas;
}

const isRandomDateDifMoreThanADay = () => {
    const fechaOriginalRandom = localStorage.getItem("fechaOriginalRandom");
    if (fechaOriginalRandom === null)
        return false;

    const fechaLocal = new Date();
    const diferenciaMinutos = Math.abs(Math.round(((fechaLocal.getTime() - Date.parse(localStorage.getItem("fechaOriginalRandom"))) / 1000 / 60)));
    let  diferenciaHoras = Math.abs(Math.round(diferenciaMinutos / 60));

    if (diferenciaHoras <= sugerenciasPerso.horasCorteSugerencias) //Default: 24
        return false;

    localStorage.removeItem("randomCorteSugerencias");
    localStorage.removeItem("fechaOriginalRandom");
    return true;
}

export const getValoresDeCorte = () => {
    //Liftigniter
    const arrayOpcionesProviders = sugerenciasPerso.providers;
    const randomOptionProvider = arrayOpcionesProviders[Math.floor(Math.random() * arrayOpcionesProviders.length)];
    
    if (localStorage.getItem("randomCorteSugerencias") === null || isRandomDateDifMoreThanADay()) {
        localStorage.setItem("randomCorteSugerencias", randomOptionProvider);
        localStorage.setItem("fechaOriginalRandom", new Date());
    }
    
    if (localStorage.getItem("randomCorteSugerencias") === "Liftigniter") {
        const container = document.querySelector("div[data-module=\"nota-sugeridas\"]");
        if (container !== null && container !== undefined) {
            container.setAttribute("data-suggestion-engine","liftigniter");
            
            return undefined;
            //return {};
        }
    } else {
        const cortes = sugerenciasPerso;
        const arrayOpciones = cortes.opcionesCorte;
        const randomOption = arrayOpciones[Math.floor(Math.random() * arrayOpciones.length)];

        const objResult = {
            usuario : true,
            dias: [],
            categorias: [],
            horas : [],
            diaYHorario : []
        }

        localStorage.removeItem("sugerenciasTipoCorte");

        switch (randomOption) {
            case "usuario":
                objResult.usuario = true;
                localStorage.setItem("sugerenciasTipoCorte", JSON.stringify("default"));
                break;
            case "usuarioDias":
                {
                    const date = new Date();
                    let diaDeSemana = date.getDay();
                    //TODO: que pasas si pedimos un numero de dia mayor al que estamos? lo validamos?
                    diaDeSemana = diaDeSemana === 0 ? 7 : diaDeSemana;
                    objResult.dias = [diaDeSemana];
                    localStorage.setItem("sugerenciasTipoCorte", JSON.stringify("dia"));
                }
                break;
            case "usuarioCategorias":
                {
                    let jsonCategoria = JSON.parse(localStorage.getItem("obtenerPreferibles"));
                    jsonCategoria = jsonCategoria.filter(x => x.tipoId === 20);
                
                    const arrCategorias = [];
                    jsonCategoria.map((o) => {
                        arrCategorias.push(o.id);
                    });
                    objResult.categorias = arrCategorias;
                    localStorage.setItem("sugerenciasTipoCorte", JSON.stringify("categoria"));
                }
                break;
            case "usuarioHoras":
                objResult.horas = getRangoHorario(cortes.rangosDiscretizacion);
                localStorage.setItem("sugerenciasTipoCorte", JSON.stringify("hora"));
                break;
            case "usuarioDiaHorario":
                {
                    const date = new Date();
                    let diaDeSemana = date.getDay();
                    //TODO: que pasas si pedimos un numero de dia mayor al que estamos? lo validamos?
                    diaDeSemana = diaDeSemana === 0 ? 7 : diaDeSemana;
                    objResult.dias = [diaDeSemana];
                    objResult.horas = getRangoHorario(cortes.rangosDiscretizacion);
                    localStorage.setItem("sugerenciasTipoCorte", JSON.stringify("fechaYhora"));
                }
                break;
        }
        return objResult;
    }

}   

const getRangoHorario = (arrayRangosHorarios) => {
    //["00,01,02,03,04,05,06,07", "08,09,10", "11,12,13,14", "15,16,17,18", "18,19,20", "20,21,22,23"];

    const date = new Date(); //new Date("July 21, 1983 01:15:00")
    let hora = date.getHours();
    hora = (`0${hora}`).slice(-2);

    let valor;
    arrayRangosHorarios.map((o, index) => {
        o.split(",").find((h) => {
            if (h === hora) valor = index;
        });
    });

    return arrayRangosHorarios[valor];
}

const getArticleSugerido = (nota, width, widthTablet,toi) => {
    let imgHtml = "";
    let toiPos = "toi".concat(toi.toString());
    let tipoCorte = JSON.parse(localStorage.getItem("sugerenciasTipoCorte"));

    if (nota.datos.imagen != null && nota.datos.imagen.id > 0 && nota.datos.imagen.extension != null && nota.datos.imagen.extension != "") {
        imgHtml += `<source media="(min-width: 768px)" srcset="${BucketTools.urlBucketBalance(urlBucket, nota.datos.imagen.id, "", width, nota.datos.imagen.extension)}">`;
        imgHtml += `<img src="${BucketTools.urlBucketBalance(urlBucket, nota.datos.imagen.id, "", widthTablet, nota.datos.imagen.extension)}"/>`;
    }
    
    return `<article title="" class="nota"  data-id="${nota.contenido_id}" data-notaid="${nota.contenido_id}" data-source="sugerencia-${tipoCorte}" data-pos="${toiPos}">
              <a class="figure" href="${nota.contenido_id}-${Utilities.FormatearUrl(nota.titulo)}">         
                <picture>
                     ${imgHtml}
                </picture>
              </a>
              <h2><a href="${nota.contenido_id}-${Utilities.FormatearUrl(nota.titulo)}">${nota.titulo}</a></h2>
          </article>`;
}

const renderNotasPieCategoria = (data , categoriaRandom, idsCategoria, randomOptionProvider) => {
    const container = document.getElementById("bloque-4");
    
    if (!container || data == null) return;
    container.setAttribute("data-source", randomOptionProvider);

    let heightBucket;
    let widthBucket;
    let conAutor;
    let categoria;
    let listado;
    let toi = 901;
    for (let j = 0; j < categoriaRandom.length; j++) {
        const isCategoriaOTag = (idsCategoria.indexOf(categoriaRandom[j]) > -1) ? "categorias" : "tags";
        
        if (data[isCategoriaOTag][categoriaRandom[j]].items.length > 0) {
            categoria = (isCategoriaOTag === "categorias") ? data[isCategoriaOTag][categoriaRandom[j]].items[0].categoriaDescripcion :  data[isCategoriaOTag][categoriaRandom[j]].items[0].tags.find(x => x.id === categoriaRandom[j]).valor;
            let categoriaNormalizada = Utilities.FormatearUrl(categoria);
            listado = `<section data-is-block="true" data-block-name="n_recomendacion-${categoriaNormalizada}" data-diagramacion-id="0">`;
            const notas = data[isCategoriaOTag][categoriaRandom[j]].items.slice(0, 5);
            listado += `<h3>${categoria}</h3>`;

            for (let i = 0; i < notas.length; i++) {
                const nota = notas[i];
                const conImagen = nota.imagenes instanceof Array && nota.imagenes.length > 0 && nota.imagenes[0].src != null && nota.imagenes[0].src !== "";
                (i === 0) ? heightBucket = 183 : heightBucket = 80;
                (i === 0) ? widthBucket = 282 : widthBucket = 107;
                (nota.template_id !== null && nota.template_id === 3) ? conAutor = "autor": conAutor = "";
                let toiPos = "toi".concat(toi.toString());
                listado += `<article class="nota ${conAutor} floatFix" data-id="${nota.id}" data-notaid="${nota.id}" data-source="ultimas" data-pos="${toiPos}">`;

                if (i === 0) {
                    listado += `<a class="figure" href="${nota.url}" "data-numero="${i}" data-tipo="normal-primera">`;
                    listado += conImagen ? `<img src="${BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, heightBucket)}"/>`: "";
                    listado += `</a>`;
                } else {
                    if (conAutor === "") { //conImagen && Si se lo saco qu eonda?
                        listado += `<a class="figure"  href="${nota.url}" data-numero="${i}" data-tipo="normal">`;
                        listado += conImagen ? `<img src="${BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, heightBucket)}"/>`: "";
                        listado += `</a>`;
                    } else if (conAutor !== "" && nota.autores[0].hdImagenId !== null && nota.autores[0].hdImagenExtension) {
                        listado += `<a class="figure"  href="${nota.url}" data-numero="${i}" data-tipo="autor">`;
                        listado += nota.autores instanceof Array && nota.autores.length > 0 && nota.autores[0].hdImagenId != null && nota.autores[0].hdImagenId != 0 && nota.autores[0].hdImagenExtension != null && nota.autores[0].hdImagenExtension != ""
                            ? `<img src="${BucketTools.urlBucketBalance(bucket,nota.autores[0].hdImagenId,heightBucket,"",nota.autores[0].hdImagenExtension)}"/>`
                            : "";
                        listado += `</a>`;
                    }
                }

                listado += `<h2><a href="${nota.url}">${nota.titulo}</a></h2>`;
                if (conAutor !== "" && nota.autores instanceof Array && nota.autores.length > 0 ) {
                    listado += `<a href="${Utilities.formatoUrlAcuAutor(nota.autores[0].valor, nota.autores[0].id)}" class="autor">${nota.autores[0].valor}</a>`;
                }
                listado += `</article>`;
                toi++;
            }
            listado += "</section>";
            container.insertAdjacentHTML("afterbegin", listado);
        }
    }
}

const renderSugerenciaNewsletter = (data) => {
    let suscripcionPendiente = localStorage.getItem("suscripcionPendiente");
    let fechaSuscripcionPendiente = localStorage.getItem("fechaSuscripcionPendiente");
    let token = Cookie.LeerCookie("token");
    let tiempoCacheMilisegundos = 300000;///TODO:Cambiar a configuracion
    let dif = tiempoCacheMilisegundos;

    if (fechaSuscripcionPendiente !== null) {
        dif = Date.now() - fechaSuscripcionPendiente;
    }

    if (token !== "" && suscripcionPendiente !== null && dif < tiempoCacheMilisegundos) {
        let objPendiente = data.filter(p => p.servicioId === parseInt(suscripcionPendiente));
        if (objPendiente.length > 0) {
            let tituloPendiente = objPendiente[0].titulo;
            renderCajaSuscribir(tituloPendiente);
        }

        suscribirNewsletterAjax(data, token, suscripcionPendiente);
        localStorage.removeItem("suscripcionPendiente");
        localStorage.removeItem("fechaSuscripcionPendiente");
    } else if (data.length > 0) {
        if (suscripcionPendiente !== null) {
            localStorage.removeItem("suscripcionPendiente");
            localStorage.removeItem("fechaSuscripcionPendiente");
        }

        let sinSuscripcion = data.filter(d => d.suscripto === 0);
        if (sinSuscripcion.length === 0) {
            return;
        }
  
        let sugerenciasSuscripcion = [];
        for (let i = 0; sinSuscripcion.length > i; i++) {
            sugerenciasSuscripcion.push(sinSuscripcion[i].servicioId);
        }

        let categoria = document.querySelector('div[data-categoriaid]');
        let categoriaId = (categoria != null) ? categoria.getAttribute('data-categoriaid') : -1;
        let servicioIdPorCategoria =  newsletter.find(x => x.categoriaId == categoriaId);
        servicioIdPorCategoria = servicioIdPorCategoria != undefined ? servicioIdPorCategoria.servicioId : -1;
        //Me fijo si el diccionario de newsletter coincide con la categoria de la nota
        let matchNewsDictionary =  sugerenciasSuscripcion.find(n => n == servicioIdPorCategoria);
        
        let newsRandom = (matchNewsDictionary != undefined) ? [matchNewsDictionary] : Utilities.getRandom(sugerenciasSuscripcion, 1);

        let objSugerencia = newsRandom.length > 0
            ? data.filter(x => x.servicioId === newsRandom[0])
            : [];

        if (objSugerencia.length > 0) {
            let tituloSugerencia = objSugerencia[0].titulo;
            renderCajaSuscribir(tituloSugerencia);
        }

        let btn = document.getElementById("suscribirse");
        if (btn == null)
            return;
        if (token !== "") {
            btn.addEventListener("click", () => { suscribirNewsletterAjax(data, token, newsRandom) });
        } else {
            btn.addEventListener("click", () => { loguearYSuscribir(newsRandom); });
        }
    }
}

const renderCajaSuscribir = (tituloADibujar) => {
    let boton = document.createElement("BUTTON");
    let textoBoton = document.createTextNode("SUSCRIBIRME");
    boton.setAttribute("id", "suscribirse");
    boton.appendChild(textoBoton);

    const containerFinCuerpo = document.getElementsByClassName("fin-cuerpo")[0];
    const containerSegunda = document.getElementsByClassName("segunda floatFix")[0];

    const container = containerFinCuerpo !== undefined
                            ? containerFinCuerpo
                                : containerSegunda !== undefined
                                    ? containerSegunda
                                    : false;
    
    if (!container) return;
    let recomendacion = "<div class='titulares-del-dia'>";
    recomendacion += "<span class='icon-mail-line'></span>";
    recomendacion += `<div><b>${tituloADibujar}</b>`;
    recomendacion += "<p id='textSuscripcion'>Suscribite al newsletter</p>";
    recomendacion += "</div>";
    recomendacion += boton.outerHTML;
    recomendacion += "<span class='load' style='display:none;'></span>";
    recomendacion += "<span id='respuesta' style='display:none;'>¡Ya estás suscripto!</span>";

    recomendacion += "</div>";
    container.insertAdjacentHTML("beforeend", recomendacion);
}
const saveNewsletterLocalStorage = (data) => {
    localStorage.setItem("fechaSugerenciaTitulares", Date.now().toString());
    localStorage.setItem("sugerenciasTitulares", JSON.stringify(data));
    renderSugerenciaNewsletter(data);
}
const saveNewsletterLocalStorageDefault = (data) => {
    localStorage.setItem("sugerenciasTitularesDefault", JSON.stringify(data));
    renderSugerenciaNewsletter(data);
}

export const getSugerenciasPie = () => {
    let data = [];
    let idsRandoms = [];
    let idsCategorias = [];
    let idsTags = [];
    let orderCategorias = [];
    let orderTags = [];
    let pathCategorias = "";
    let urlRoot = "";

    const arrayProviders = sugerenciasPie[0].providers;
    let randomOptionProvider = arrayProviders[Math.floor(Math.random() * arrayProviders.length)];

    switch (randomOptionProvider) {
        case "categoria":
            data = sugerenciasPie[0].categoriasPosibles.concat(sugerenciasPie[0].tagsPosibles);
            idsRandoms = Utilities.getRandom(data, sugerenciasPie[0].cantidad);
            idsCategorias = sugerenciasPie[0].categoriasPosibles.filter(x => idsRandoms.indexOf(x) > -1);
            idsTags = sugerenciasPie[0].tagsPosibles.filter(x => idsRandoms.indexOf(x) > -1);
            
            orderCategorias = JSON.parse(JSON.stringify(idsCategorias)).sort((a, b) => a - b);
            orderTags = JSON.parse(JSON.stringify(idsTags)).sort((a, b) => a - b);
            pathCategorias =  orderCategorias.join() + "&tagsId=" + orderTags.join() + "&c=5";
            urlRoot = urlApiCategorias;

            randomOptionProvider = "ultimas";
            break;
        case "ranking":
            data = sugerenciasPie[0].categoriasPosibles; //No se agrega el tag de videos.
            idsRandoms = Utilities.getRandom(data, sugerenciasPie[0].cantidad);
            idsCategorias = sugerenciasPie[0].categoriasPosibles.filter(x => idsRandoms.indexOf(x) > -1);

            pathCategorias =  JSON.parse(JSON.stringify(idsCategorias)).sort((a, b) => a - b);
            urlRoot = urlRankingMultiplesCategoriaUrl;
            break;
    }

    Ajax.get(urlRoot + pathCategorias)
        .then((rs) => renderNotasPieCategoria(normalizeSugerenciasPieObject(JSON.parse(rs)), idsRandoms, idsCategorias, randomOptionProvider));
}

const normalizeSugerenciasPieObject = (data) => {
    const normalizedObject = {};

    if (data.categorias !== undefined && data.tags !== undefined)
        return data;

    normalizedObject.categorias = data;
    normalizedObject.tags = {};

    return normalizedObject;
}

export const getNewsletter = () => {
    const fechaSugerencia = localStorage.getItem("fechaSugerenciaTitulares"),
        sugerenciasData = JSON.parse(localStorage.getItem("sugerenciasTitulares")),
        tokenStorage = localStorage.getItem("token"),
        sugerenciaDataDefault = JSON.parse(localStorage.getItem("sugerenciasTitularesDefault"));
    let tiempoCacheMilisegundos = 300000; ///TODO:Cambiar a configuracion
    let dif = 0;

    if (tokenStorage != null) {
        //se fija que el localstorage tenga datos y el token coincida con el guardado
        if (fechaSugerencia != null && sugerenciasData != null) {
            dif = Date.now() - fechaSugerencia;
            //se fija que no haya vencido el cache
            if (dif < tiempoCacheMilisegundos) {
                renderSugerenciaNewsletter(sugerenciasData);
            } else {
                //vencio el cache entonces va a buscar de nuevo la data actualiza el localstorage y renderea
                obtenerSuscripciones(tokenStorage);
            }
        } else {
            obtenerSuscripciones(tokenStorage);
        }
    } else {
        //Si no esta logueado, se fija que tenga informacion en el LocalStorage
        if (sugerenciaDataDefault != null) {
            // dibuja con la data ya existente
            renderSugerenciaNewsletter(sugerenciaDataDefault);
        } else {
            obtenerSuscripciones("default");
        }
    }
}

const obtenerSuscripciones = (tipo) => {
    if (tipo === "default") {
        Ajax.post(urlApiNewsletter)
            .then(rs => JSON.parse(rs))
            .then(saveNewsletterLocalStorageDefault)
            .catch(err => console.log("***Error en obtenerSuscripciones - Default: " + err));
    } else {
        let objHeaders = {
            "X-Token": tipo
        }
        Ajax.post(urlApiNewsletter + "PorUsuario", "", objHeaders)
            .then(rs => JSON.parse(rs))
            .then(saveNewsletterLocalStorage)
            .catch(err => console.log("***Error en obtenerSuscripciones: " + err));
    }
}

const suscribirNewsletterAjax = (data, token , suscribirse) => {
    let serviciosYaSuscripto = data.filter(s => s.suscripto === 1); 
    let urlSuscribirse = urlApiSuscribirse;
    let stringIds = "";
    if (serviciosYaSuscripto.length > 0) {
        for (let k = 0; serviciosYaSuscripto.length > k; k++) {
            stringIds += serviciosYaSuscripto[k].servicioId + ",";
        }
    }
    stringIds += suscribirse;
    let objParam = {
        "servicios_ids": stringIds,
        "acepta_novedades":null
    }
    let objHeaders = {
        "Content-Type":"application/json",
        "X-Token": token
    }
    suscribirNewsletterLogueado(urlSuscribirse, objParam ,objHeaders);
}

const suscribirNewsletterLogueado = (url ,objParam , objHeaders) => {
    document.getElementById( "suscribirse" ).style.display = "none";
    let load =  document.querySelector(".titulares-del-dia .load");
  //  let respuesta =  document.querySelector(".titulares-del-dia #respuesta");
    load.style.display = "block";
    Ajax.post(urlApiSuscribirse , objParam , objHeaders).then(suscripcionCorrecta).catch(suscripcionError);
    localStorage.removeItem("sugerenciasTitulares");
}

const loguearYSuscribir = (newsRandom) => {
    document.getElementById( "suscribirse" ).style.display = "none";
    let load =  document.querySelector(".titulares-del-dia .load");
    load.style.display = "block";
    localStorage.setItem("tareaPendiente", newsRandom);
    localStorage.setItem("fechaPendiente", Date.now().toString());
    localStorage.removeItem("sugerenciasTitulares");
    location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
}

const suscripcionCorrecta = () => {
    //document.getElementById("textSuscripcion").innerText = "¡Ya estás suscripto!";
    let load =  document.querySelector(".titulares-del-dia .load");
    let respuesta =  document.querySelector(".titulares-del-dia #respuesta");
    load.style.display = "none";
    respuesta.style.display = "inline-block";
    setTimeout(function(){ respuesta.classList.add("bg-letter"); }, 200);
    localStorage.removeItem("tareaPendiente");
    localStorage.removeItem("fechaPendiente");
}

const suscripcionError = () => {
    let load =  document.querySelector(".titulares-del-dia .load");
    let respuesta =  document.querySelector(".titulares-del-dia #respuesta");
    load.style.display = "none";
    respuesta.innerHTML = "¡Ups volvé a intentarlo!";
    respuesta.style.display = "inline-block";
    
   
    //document.getElementById("textSuscripcion").innerText = "¡Ups volvé a intentarlo!";
    document.getElementById( "suscribirse" ).style.display = "block";

}


export const ohlalaNewsletterEspecial = () => {
    if (document.querySelector('div[data-type="newsletter-ohlala"]') != null) {
        const fechaSugerencia = localStorage.getItem("fechaSugerenciaTitulares"),
            sugerenciasData = JSON.parse(localStorage.getItem("sugerenciasTitulares")),
            tokenStorage = localStorage.getItem("token"),
            tokenCookie = Cookie.LeerCookie("token"),
            sugerenciaDataDefault = JSON.parse(localStorage.getItem("sugerenciasTitularesDefault"));
        let tiempoCacheMilisegundos = 300000; ///TODO:Cambiar a configuracion
        let dif = 0;

        if (tokenStorage != null && tokenStorage == tokenCookie) {
            if (fechaSugerencia != null && sugerenciasData != null) {
                dif = Date.now() - fechaSugerencia;
                //se fija que no haya vencido el cache
                if (dif < tiempoCacheMilisegundos) {
                    //vencio el cache entonces va a buscar de nuevo la data actualiza el localstorage y renderea
                    funcionesOhlalaNewsletter(sugerenciasData);
                } else {
                    obtenerSuscripcionesOhlala(tokenStorage);
                }
            } else {
                obtenerSuscripcionesOhlala(tokenStorage);
            }
        } else {
            let divNews = document.querySelector('div[data-type="newsletter-ohlala"]');
            let btnSuscribite = divNews.querySelector('button[data="iconOhlala"]');

            if (btnSuscribite != null) {
                btnSuscribite.addEventListener("click",
                    () => {
                        location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
                    });
                divNews.style.display = "block";

            }
        }


        //    <button class="suscribite" data="suscribiteOhlala">Suscribite</button>
        //    <button class="icon-derecha" 5="" data="iconOhlala"></button>
        //    <span class="load" style="display:none;" data="loadOhlala"></span>
        //    <label id="respuesta" style="display:none;" data="rtaOhlala">¡Ya estás suscripto!</label>
    }

}

const obtenerSuscripcionesOhlala = (tipo) => {

    if (tipo === "default") {
        Ajax.post(urlApiNewsletter)
            .then(rs => JSON.parse(rs))
            .then(saveNewsOhlalaDefault)
            .catch(err => console.log("***Error en obtenerSuscripcionesOhlala - Default: " + err));
    } else {
        let objHeaders = {
            "X-Token": tipo
        }
        Ajax.post(urlApiNewsletter + "PorUsuario", "", objHeaders)
            .then(rs => JSON.parse(rs))
            .then(saveNewsOhlala)
            .catch(err => console.log("***Error en obtenerSuscripcionesOhlala: " + err));
    }

}

const saveNewsOhlala = (data) => {
    localStorage.setItem("fechaSugerenciaTitulares", Date.now().toString());
    localStorage.setItem("sugerenciasTitulares", JSON.stringify(data));
    funcionesOhlalaNewsletter(data);
}
const saveNewsOhlalaDefault = (data) => {
    localStorage.setItem("sugerenciasTitularesDefault", JSON.stringify(data));
    funcionesOhlalaNewsletter(data);
}


const funcionesOhlalaNewsletter = (data) => {
    let divOhlala = document.querySelector('div[data-type="newsletter-ohlala"]');
    let btnSuscribite = divOhlala.querySelector('button[data="suscribiteOhlala"]');
    let btnIcon = divOhlala.querySelector('button[data="iconOhlala"]');
    let spanLoad = divOhlala.querySelector('span[data="loadOhlala"]');
    let yaSuscriptoOhlala = data.filter(s => s.servicioId == 107 && s.suscripto == 1);

    if (yaSuscriptoOhlala.length == 0) {
        divOhlala.style.display = "block";
        btnSuscribite.addEventListener("click",
            () => {
                spanLoad.style.display = "block";
                btnIcon.style.display = "none";
                suscribirOhlala(data, divOhlala);

            });
    }
}

const suscribirOhlala = (data , divNews) => {
    let serviciosYaSuscripto = data.filter(s => s.suscripto == 1); 
    let urlSuscribirse = urlApiSuscribirse;
    let token = localStorage.getItem("token");
    let stringIds = "";
    if (serviciosYaSuscripto.length > 0) {
        for (let k = 0; serviciosYaSuscripto.length > k; k++) {
            stringIds += serviciosYaSuscripto[k].servicioId + ",";
        }
    }
    stringIds += 107;
    //stringIds += 2;
    let objParam = {
        "servicios_ids": stringIds,
        "acepta_novedades":null
    }
    let objHeaders = {
        "Content-Type":"application/json",
        "X-Token": token
    }
    suscribirOhlalaLogeado(urlSuscribirse, objParam ,objHeaders, divNews);

}

const suscribirOhlalaLogeado = (url ,objParam , objHeaders , divNews) => {
    let btnSuscribite = divNews.querySelector('button[data="suscribiteOhlala"]');
    let spanLoad = divNews.querySelector('span[data="loadOhlala"]');
    spanLoad.style.display = "block";
    btnSuscribite.style.display = "none";
   
    Ajax.post(urlApiSuscribirse , objParam , objHeaders)
        .then(ohlalaSuscripcionCorrecta(divNews))
        .catch(err => {
            console.log(err);
            ohlalaSuscripcionIncorrecta(divNews);
        });
    localStorage.removeItem("sugerenciasTitulares");
}

const ohlalaSuscripcionCorrecta = (divNews) => {
    let labelRta = divNews.querySelector('label[data="rtaOhlala"]');
    let spanLoad = divNews.querySelector('span[data="loadOhlala"]');

    spanLoad.style.display = "none";
    labelRta.style.display = "inline-block";
    setTimeout(function(){ labelRta.classList.add("bg-letter"); }, 200);


}

const ohlalaSuscripcionIncorrecta = (divNews) => {
    let labelRta = divNews.querySelector('label[data="rtaOhlala"]');
    let spanLoad = divNews.querySelector('span[data="loadOhlala"]');
    let btnSuscribite = divNews.querySelector('button[data="suscribiteOhlala"]');

    setTimeout(function() {
        spanLoad.style.display = "none";
        btnSuscribite.style.display = "none";
        labelRta.innerHTML = "¡Ups volvé a intentarlo!";
        labelRta.style.display = "block";
    }, 200);

  

}






// WEBPACK FOOTER //
// ./Statics/scripts/nota/sugerencias.js